module.exports = __webpack_public_path__ + "img/svg/whatsapp-2d50195b.svg";